<template>
    <d-container fluid class="main-content-container px-4">
        <d-row no-gutters class="page-header py-4">
            <d-col col sm="4" class="text-center text-sm-left mb-4 mb-sm-0">
                <h3 class="page-title">API access</h3>
            </d-col>
        </d-row>
        <d-row v-if="checkPermission(permissionTypes.apiRead)">
            <d-col lg="4" class="mx-auto mt-4">
                <d-card class="card-small mb-4 pt-3">
                    <d-card-header class="border-bottom text-center">
                        <div class="mb-3 mx-auto">
                            <i class='fas fa-server api-icon'></i>
                        </div>
                        <h4 class="mb-0">API for cloaked links</h4>
                    </d-card-header>
                    <d-list-group flush>
                        <d-list-group-item>
                            <d-form>
                                <d-form-row>
                                    <d-col class="mb-3">
                                        If you use cloaked links without supported link cloaking plugins (Pretty Links or Thirsty Affiliates) you need to use our API for cloaked links. This API can be used to insert anonymized sub-id's in you affiliate links realtime.
                                    </d-col>
                                </d-form-row>
                            </d-form>
                        </d-list-group-item>
                    </d-list-group>
                    <d-card-footer class="border-top d-flex justify-content-end" />
                </d-card>
            </d-col>
            <d-col lg="8" class="mx-auto mt-4">
                <d-card class="card-small edit-user-details mb-4">
                    <d-card-header class="border-bottom">
                        <h6 class="m-0">Your current API key</h6>
                    </d-card-header>
                    <d-card-body class="p-0">
                        <div class="p-4">
                            <d-form>
                                <d-form-row class="mx-4">
                                    <d-col md="12" class="mt-3 mb-2">
                                        <d-form-text tag="p" class="text-muted m-0">Developer id</d-form-text>
                                    </d-col>
                                    <d-col cols="9" class="mb-3 script-tag">
                                        <d-form-text tag="h6" class="m-0">
                                            {{ Developer.developer_id }}
                                        </d-form-text>
                                    </d-col>
                                    <d-col md="12" class="mt-3 mb-2" v-if="checkPermission(permissionTypes.apiWrite)">
                                        <d-form-text tag="p" class="text-muted mb-2 m-0">Password</d-form-text>
                                        <d-form-text tag="h6" :class="['alert', apiCssClassName]">
                                            <span class="text-white">{{ apiText }}</span>
                                        </d-form-text>
                                        <div v-if="isAvailable">
                                            <button type="button" @click="deleteDeveloperId" class="btn mt-3 btn-danger btn-sm">Disable API access</button>
                                            <button type="button" @click="updateDeveloperId" class="btn ml-3 mt-3 btn-success btn-sm">Generate API key</button>
                                        </div>
                                        <button type="button" v-else @click="restore" class="mt-3 btn btn-secondary btn-sm">Enable API access</button>
                                    </d-col>
                                    <d-col md="12" class="mt-4">
                                        <d-form-text tag="p" class="m-0">
                                            Warning This key gives full access to your Ivanhoe.io sub-id generation. Keep it safe and do not publish.
                                        </d-form-text>
                                    </d-col>
                                </d-form-row>
                            </d-form>
                        </div>
                    </d-card-body>
                </d-card>
            </d-col>
        </d-row>
        <no-permission-message v-else />
    </d-container>
</template>

<script>
    import { DeveloperService } from '@/main';
    import notification from '@/mixins/notification';
    import permissions from '../../mixins/permissions';

    export default {
        mixins: [notification, permissions],

        data() {
            return {
                apiText: '',
                apiCssClassName: '',
                Developer: '',
                isAvailable: true
            };
        },
        methods: {
            async getDeveloperId() {
                try {
                    this.Developer = await DeveloperService.get()
                    if (this.Developer !== null && this.Developer.deleted_at == null) {
                        this.apiText = "Please use your current Developer Id and password or generate new ones."
                        this.apiCssClassName = "alert-warning"
                    } else {
                        this.apiText = "To start using the IVANHOE.io API and get your API access key you need to enable Api access."
                        this.apiCssClassName = "alert-warning"
                    }

                } catch(e) {
                    console.log(e)
                    this.showNotification('warn', 'We have a problem', 'Oops! cant get developer id')
                }
            },

            async updateDeveloperId() {
                try {
                    this.Developer = await DeveloperService.update()
                    this.apiText = this.Developer.showed_pass
                    this.apiCssClassName = "alert-success"
                } catch(e) {
                    console.log(e)
                    this.showNotification('warn', 'We have a problem', 'Oops! cant get developer id')
                }
            },

            async deleteDeveloperId() {
                try {
                    this.Developer = await DeveloperService.delete()
                    this.isAvailable = false
                    this.apiText = "To start using the IVANHOE.io API and get your API acces key you need to enable Api access."
                    this.apiCssClassName = "alert-danger"
                } catch(e) {
                    console.log(e)
                    this.showNotification('warn', 'We have a problem', 'Oops! cant get developer id')
                }
            },

            restore() {
                this.isAvailable = true
                this.apiText = "Please use your current Developer Id and password or generate new ones."
                this.apiCssClassName = "alert-warning"
            },
        },

        created() {
            this.getDeveloperId()
        },
    };
</script>
